import Joi from 'joi';
import { isBefore, isValid, isWeekend } from 'date-fns';

const today = new Date();
today.setHours(0, 0, 0, 0);

const isValidStartDateForPost = (start, helpers) => {
  if (!isValid(start)) return helpers.error('date.invalid');
  if (isWeekend(start)) return helpers.error('date.weekend');

  return start;
};

const isValidEndDateForPost = (end, helpers) => {
  if (!isValid(end)) return helpers.error('date.invalid');
  const selectedStartDate = helpers?.state?.ancestors?.[0]?.startDate;
  if (selectedStartDate && isBefore(end, selectedStartDate)) return helpers.error('date.startBeforeEnd');
  if (isWeekend(end)) return helpers.error('date.weekend');

  return end;
};

const postRemotePostSchema = {
  startDate: Joi.date()
    .custom(isValidStartDateForPost)
    .required()
    .messages({
      'any.required': 'common.form.requiredField',
      'date.base': 'common.form.requiredField',
      'date.empty': 'common.form.requiredField',
      'date.invalid': 'common.form.date.invalid',
      'date.weekend': 'common.form.date.weekend',
    }),
  endDate: Joi.date()
    .custom(isValidEndDateForPost)
    .required()
    .messages({
      'any.required': 'common.form.requiredField',
      'date.base': 'common.form.requiredField',
      'date.empty': 'common.form.requiredField',
      'date.startBeforeEnd': 'common.form.date.startBeforeEnd',
      'date.weekend': 'common.form.date.weekend',
    }),
  recurrence: Joi.object({}).allow(null),
  place: Joi.string()
    .messages({
      'string.base': 'common.form.requiredField',
      'string.empty': 'common.form.requiredField',
    }),
  address: Joi.string()
    .when('place', { is: 'home', then: Joi.allow('') })
    .messages({
      'string.base': 'common.form.requiredField',
      'string.empty': 'common.form.requiredField',
    }),
  isExceptional: Joi.bool(),
  comment: Joi.string()
    .max(255)
    .when('isExceptional', { is: false, then: Joi.allow('') })
    .messages({
      'string.base': 'common.form.requiredField',
      'string.empty': 'common.form.requiredField',
      'string.max': 'common.form.comment',
    }),
};

export const postRemotePostSchemaAny = Joi.object({
  resourceId: Joi.object({
    value: Joi.string(),
    label: Joi.string(),
    icon: Joi.object().allow(null),
  })
    .messages({
      'object.base': 'common.form.requiredField',
    }),
  ...postRemotePostSchema,
});

export const postRemotePostSchemaOwn = Joi.object({
  resourceId: Joi.object({
    value: Joi.string(),
    label: Joi.string(),
    icon: Joi.object().allow(null),
  }).allow(null),
  ...postRemotePostSchema,
});
